import { LogoLibertyMutualHoriz, LogoSafecoHoriz, LogoCobrand } from '@lmig/lmds-react-logos';
export var LOGOS = {
  safeco: LogoSafecoHoriz,
  liberty: LogoLibertyMutualHoriz,
  cobrand: LogoCobrand
};